import { useState, useEffect, useRef } from 'react';
import './slider.scss';

function Slider({ images, title }) {
  const [imageIndex, setImageIndex] = useState(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const changeSlide = (direction) => {
    setImageIndex((prev) => {
      if (direction === 'left') {
        return prev === 0 ? images.length - 1 : prev - 1;
      } else {
        return prev === images.length - 1 ? 0 : prev + 1;
      }
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      changeSlide('left');
    } else if (event.key === 'ArrowRight') {
      changeSlide('right');
    } else if (event.key === 'Escape') {
      setImageIndex(null);
    }
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchStartX.current - touchEndX.current;
    const threshold = 50;

    if (Math.abs(swipeDistance) > threshold) {
      if (swipeDistance > 0) {
        changeSlide('right');
      } else {
        changeSlide('left');
      }
    }
  };

  useEffect(() => {
    if (imageIndex !== null) {
      window.addEventListener('keydown', handleKeyDown);

      const sliderEl = document.querySelector('.fullSlider');
      if (sliderEl) {
        sliderEl.addEventListener('touchstart', handleTouchStart);
        sliderEl.addEventListener('touchmove', handleTouchMove);
        sliderEl.addEventListener('touchend', handleTouchEnd);
      }

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        if (sliderEl) {
          sliderEl.removeEventListener('touchstart', handleTouchStart);
          sliderEl.removeEventListener('touchmove', handleTouchMove);
          sliderEl.removeEventListener('touchend', handleTouchEnd);
        }
      };
    }
  }, [imageIndex]);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/noproduct.webp';
  };

  return (
    <div className="slider">
      {imageIndex !== null && (
        <div className="fullSlider">
          <div className="arrow" onClick={() => changeSlide('left')}>
            <img src="/arrow.png" alt="Previous" />
          </div>
          <div className="imgContainer">
            <img
              src={images[imageIndex]?.src}
              alt={title}
              onError={handleImageError}
            />
          </div>
          <div className="arrow" onClick={() => changeSlide('right')}>
            <img src="/arrow.png" className="right" alt="Next" />
          </div>
          <div className="close" onClick={() => setImageIndex(null)}>
            X
          </div>
        </div>
      )}

      <div className="bigImage">
        <img
          src={images[0]?.src || '/noproduct.webp'}
          alt={title}
          onClick={() => setImageIndex(0)}
          onError={handleImageError}
        />
      </div>

      <div className="smallImages">
        {images.slice(1).map((image, index) => (
          <img
            key={index}
            src={image?.src || '/noproduct.webp'}
            alt={title}
            onClick={() => setImageIndex(index + 1)}
            onError={handleImageError}
          />
        ))}
      </div>
    </div>
  );
}

export default Slider;
